import React from "react";

interface NameTableTranslatableProps {
    data: Array<{ node: { dbId: number; name: string } }>;
    onOpenForm: (id: any) => void; // Callback to open the form
}

const NameTableTranslatable: React.FC<NameTableTranslatableProps> = ({ data, onOpenForm }) => {
    return (
        <div className="overflow-x-auto shadow-md sm:rounded-lg">
            <table className="min-w-full text-center text-sm text-gray-600">
                <thead className="bg-gray-50">
                    <tr className="">
                        <th scope="col" className="px-6 py-3 text-gray-700 font-medium">
                            ID
                        </th>
                        <th scope="col" className="px-6 py-3 text-gray-700 font-medium">
                            Name
                        </th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {data.map((item) => (
                        <tr
                            key={item.node.dbId}
                            className="hover:bg-gray-100 cursor-pointer transition duration-150"
                            onClick={() => onOpenForm(item.node.dbId)}
                        >
                            <td className="px-6 py-4 font-medium text-gray-90 border">{item.node.dbId}</td>
                            <td className="px-6 py-4 border">{item.node.name}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default NameTableTranslatable;
